import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/clock.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "flex justify-center bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center border-r-0 border-gray-lp-400 border outline-none focus:shadow py-2.5 px-3",
  style: {"height":"2.435rem"}
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-4 max-w-none self-center",
    alt: "clock"
  })
], -1)
const _hoisted_3 = {
  class: "py-2.5 px-3 rounded border focus:outline-none focus:shadow w-full flex flex-row justify-between items-center",
  style: {"height":"2.435rem"}
}
const _hoisted_4 = {
  key: 0,
  class: "text-14px font-normal text-gray-lp-300"
}
const _hoisted_5 = {
  key: 1,
  class: "text-14px font-normal text-gray-lp-600"
}
const _hoisted_6 = { class: "flex flex-col h-350px" }
const _hoisted_7 = { class: "text-gray-lp-300 text-14px font-semibold font-montserrat" }
const _hoisted_8 = {
  style: {"height":"350px"},
  class: "relative overflow-y-auto scroll border border-gray-lp-400 mt-4 rounded-lg pb-2 pt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showMenu && _ctx.showMenu(...args))),
      class: "flex flex-row cursor-pointer"
    }, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", null, [
          (_ctx.displayLabel)
            ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.displayLabel), 1))
            : (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.nearestAvailableLabel), 1))
        ]),
        (_ctx.modelValue)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "flex items-center",
              style: {"cursor":"pointer"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
            }, [
              _createVNode(_component_Icons, {
                name: "icon-x",
                width: "24",
                height: "24",
                class: "w-4 text-gray-lp-600"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isMenu)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["absolute mt-1 z-30 bg-white w-50 rounded-lg border border-gray-lp-400 p-4 text-14px text-gray-lp-300 right-0", [{ 'dropdown-above': _ctx.isAbove }]]
        }, [
          _createVNode("div", _hoisted_6, [
            _createVNode("p", _hoisted_7, _toDisplayString(_ctx.titlePickup), 1),
            _createVNode("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.times, (slot) => {
                return (_openBlock(), _createBlock("div", {
                  key: slot.value,
                  onClick: ($event: any) => (_ctx.onSelectTime(slot)),
                  class: 
              `flex items-center justify-center w-full pt-3 cursor-pointer ${
                slot.disabled ? 'cursor-not-allowed' : 'hover:bg-gray-lp-700'
              } ${_ctx.isSelected(slot) ? 'bg-gray-lp-700' : ''}`
            
                }, [
                  _createVNode("div", null, [
                    _createVNode("p", {
                      class: 
                  `font-normal font-montserrat text-16px mb-4 cursor-pointer w-full ${
                    slot.disabled
                      ? 'text-gray-lp-600'
                      : _ctx.isSelected(slot)
                      ? 'text-red-lp-100'
                      : 'text-gray-lp-300'
                  }`
                
                    }, _toDisplayString(slot.label), 3)
                  ])
                ], 10, ["onClick"]))
              }), 128))
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, 
      (e) => {
        if (_ctx.isMenu) {
          e.preventDefault();
          _ctx.showMenu();
        }
      }
    ]
  ])
}